@import url('../layout-button.css');

button {
    appearance: unset;
    border: unset;
    margin: unset;
    width: 100%;
    text-align: unset;
    font: unset;
    cursor: pointer;
    background-color: unset;
}
